import React, { useEffect, useRef, useState } from "react"
import styles from "./customCursor.module.scss"

function CustomCursor() {
  const dotRef = useRef(null)
  const circleRef = useRef(null)
  
  const [hidden, setHidden] = useState(true)
  const [hovered, setHovered] = useState(false)
  const [clicked, setClicked] = useState(false)

  useEffect(() => {
    // Check if device supports touch (disable custom cursor on touchscreens)
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0
    if (isTouchDevice) return

    // Position variables
    const mouse = { x: 0, y: 0 }
    const circle = { x: 0, y: 0 }

    const onMouseMove = (e) => {
      mouse.x = e.clientX
      mouse.y = e.clientY
      setHidden(false)

      if (dotRef.current) {
        dotRef.current.style.left = `${mouse.x}px`
        dotRef.current.style.top = `${mouse.y}px`
      }
    }

    const onMouseDown = () => setClicked(true)
    const onMouseUp = () => setClicked(false)
    const onMouseLeave = () => setHidden(true)
    const onMouseEnter = () => setHidden(false)

    // Add mouse listeners
    window.addEventListener("mousemove", onMouseMove)
    window.addEventListener("mousedown", onMouseDown)
    window.addEventListener("mouseup", onMouseUp)
    document.addEventListener("mouseleave", onMouseLeave)
    document.addEventListener("mouseenter", onMouseEnter)

    // Interactivity checks: listen to hovers on links, buttons, and clickable elements
    const addHoverListeners = () => {
      const interactives = document.querySelectorAll("a, button, [role='button'], input, select, textarea, .clickable, [data-cursor='hover']")
      interactives.forEach((el) => {
        el.addEventListener("mouseenter", () => setHovered(true))
        el.addEventListener("mouseleave", () => setHovered(false))
      })
    }

    // Run hover listeners on mount and periodically (since elements dynamically render/change)
    addHoverListeners()
    const hoverInterval = setInterval(addHoverListeners, 1500)

    // Animation loop for spring lag on circle follower
    let animationId
    const lerp = (start, end, amt) => (1 - amt) * start + amt * end

    const tick = () => {
      circle.x = lerp(circle.x, mouse.x, 0.15)
      circle.y = lerp(circle.y, mouse.y, 0.15)

      if (circleRef.current) {
        circleRef.current.style.left = `${circle.x}px`
        circleRef.current.style.top = `${circle.y}px`
      }
      animationId = requestAnimationFrame(tick)
    }
    tick()

    return () => {
      window.removeEventListener("mousemove", onMouseMove)
      window.removeEventListener("mousedown", onMouseDown)
      window.removeEventListener("mouseup", onMouseUp)
      document.removeEventListener("mouseleave", onMouseLeave)
      document.removeEventListener("mouseenter", onMouseEnter)
      clearInterval(hoverInterval)
      cancelAnimationFrame(animationId)
    }
  }, [])

  return (
    <>
      <div
        ref={dotRef}
        className={`${styles.cursorDot} ${hidden ? styles.hidden : ""} ${
          clicked ? styles.clicked : ""
        } ${hovered ? styles.hovered : ""}`}
      />
      <div
        ref={circleRef}
        className={`${styles.cursorCircle} ${hidden ? styles.hidden : ""} ${
          clicked ? styles.clicked : ""
        } ${hovered ? styles.hovered : ""}`}
      />
    </>
  )
}

export default CustomCursor
